import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ButtonModule } from './../../common/button/button.module';
import { DropdownModule } from './../../common/dropdown/dropdown.module';
import { IconModule } from './../../common/icon/icon.module';
import { MailPickerModule } from './../../common/mail-picker/mail-picker.module';
import { TooltipModule } from './../../common/tooltip/tooltip.module';
import { TruncateModule } from './../../common/truncate/truncate.module';
import { RtUICoreOverlayModule } from './../../core/core.module';
import { InputModule } from './../../forms/input/input.module';
import { TypeaheadModule } from './../../forms/typeahead/typeahead.module';
import { TaggerComponent } from './tagger.component';

@NgModule({
  declarations: [TaggerComponent],
  exports: [TaggerComponent],
  imports: [
    TypeaheadModule,
    CommonModule,
    RtUICoreOverlayModule,
    ButtonModule,

    IconModule,
    DropdownModule,
    MailPickerModule,
    InputModule,
    ReactiveFormsModule,
    TooltipModule,
    TruncateModule,
  ],
})
export class TaggerModule {}
export { TaggerComponent, TaggerTag } from './tagger.component';
